import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { GlobalUser } from 'src/app/core/models/global.user.model';
import { UserService } from 'src/app/core/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return new Observable<boolean>((subscriber: Subscriber<any>) => {
      this.userService.getMyInfo().subscribe((user: GlobalUser) => {
        if (user && user.isAdministrative) return subscriber.next(true);

        if (user && !user.isAdministrative) {
          subscriber.next(false);
          this.router.navigate(['notauthorized']);
        }
      });
    });
  }
}
